/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbDocumentType } from './HchbDocumentType';
import {
    HchbDocumentTypeFromJSON,
    HchbDocumentTypeFromJSONTyped,
    HchbDocumentTypeToJSON,
} from './HchbDocumentType';

/**
 * 
 * @export
 * @interface HchbUploadDocumentTaskItem
 */
export interface HchbUploadDocumentTaskItem {
    /**
     * 
     * @type {string}
     * @memberof HchbUploadDocumentTaskItem
     */
    relationId: string;
    /**
     * 
     * @type {string}
     * @memberof HchbUploadDocumentTaskItem
     */
    relationType: HchbUploadDocumentTaskItemRelationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof HchbUploadDocumentTaskItem
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof HchbUploadDocumentTaskItem
     */
    sourceS3Key: string;
    /**
     * 
     * @type {HchbDocumentType}
     * @memberof HchbUploadDocumentTaskItem
     */
    hchbDocumentType: HchbDocumentType;
}


/**
 * @export
 */
export const HchbUploadDocumentTaskItemRelationTypeEnum = {
    Document: 'screener_document',
    AdditionalDocument: 'screener_additional_document',
    GeneratedDocument: 'screener_generated_document'
} as const;
export type HchbUploadDocumentTaskItemRelationTypeEnum = typeof HchbUploadDocumentTaskItemRelationTypeEnum[keyof typeof HchbUploadDocumentTaskItemRelationTypeEnum];


/**
 * Check if a given object implements the HchbUploadDocumentTaskItem interface.
 */
export function instanceOfHchbUploadDocumentTaskItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "relationId" in value;
    isInstance = isInstance && "relationType" in value;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "sourceS3Key" in value;
    isInstance = isInstance && "hchbDocumentType" in value;

    return isInstance;
}

export function HchbUploadDocumentTaskItemFromJSON(json: any): HchbUploadDocumentTaskItem {
    return HchbUploadDocumentTaskItemFromJSONTyped(json, false);
}

export function HchbUploadDocumentTaskItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbUploadDocumentTaskItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'relationId': json['relationId'],
        'relationType': json['relationType'],
        'fileName': json['fileName'],
        'sourceS3Key': json['sourceS3Key'],
        'hchbDocumentType': HchbDocumentTypeFromJSON(json['hchbDocumentType']),
    };
}

export function HchbUploadDocumentTaskItemToJSON(value?: HchbUploadDocumentTaskItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'relationId': value.relationId,
        'relationType': value.relationType,
        'fileName': value.fileName,
        'sourceS3Key': value.sourceS3Key,
        'hchbDocumentType': HchbDocumentTypeToJSON(value.hchbDocumentType),
    };
}

